import gql from 'graphql-tag';

export const saveConfig = gql`
  mutation saveConfig($config: SaveConfigRequest!) {
    saveConfig(config: $config) {
      _id
    }
  }
`;
